export enum KYCStatus {
  REQUIRED = 'REQUIRED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type KycStatusResponse = {
  status: KYCStatus;
  secondsLeft: number | null;
};

export type KycVerificationSessionResponse = {
  verificationSessionId: string;
  publishableKey: string;
  clientSecret: string;
  ephemeralKeySecret?: string;
  url?: string;
};

export type KycStatusStreamResponse = {
  verified?: boolean;
  errorMessage?: string | null;
  status?: KYCStatus | string;
};

export type KycStatusStreamError = Error & {
  status?: number;
  body?: string;
};
